export function buildInvoiceEmailHistoryAdvanceFilter(invoiceId: number): string {
  return `match[source_type]=invoice;match[source_id]=${invoiceId}`;
}

export function buildInvoiceEmailHistoryListFilterStr(invoiceId: number): string {
  return `filter[advance_filtering]=${encodeURIComponent(buildInvoiceEmailHistoryAdvanceFilter(invoiceId))}`;
}
